export default __webpack_public_path__ + "static/media/search.dab076c4.svg";